<template>
	<div data-route class="page">
		<div data-element="main">
			<v2-actions
				:actions="getActions"
				@actionClick="onActionClick"
			/>
			<activity
				entryRoute="teaching"
				:isPreview="true"
			/>
		</div>
		<portal
			to="modal"
			v-if="deleteConfirmationIsVisible"
		>
			<modal-inner
				@close="toggleDeleteConfirmation"
				heading="Delete activity"
			>
				<confirmation-modal
					text="Deleting the activity will permanently remove it from the lesson."
					confirmationText="Delete"
					confirmationActionId="deleteActivity"
					cancelActionId="toggleDeleteConfirmation"
					@actionClick="onActionClick"
				/>
			</modal-inner>
		</portal>
	</div>
</template>

<script>

	import Activity           from '@/components/activities/view/Activity';
	import V2Actions            from '@/components/v2/ui/V2Actions';
	import ModalInner         from '@/components/ui/modal/ModalInner';
	import ConfirmationModal  from '@/components/ui/modal/ConfirmationModal';
	import actionClick        from '@/mixins/actionClick';
	import routeParams        from '@/mixins/routeParams';
	import api                from '@/services/api';

	export default {
		layout: 'v2default',
		metaInfo () {
			if (!this.getActivityTitle) {
				return false;
			}
			return {
				title: this.getActivityTitle
			};
		},
		components: {
			Activity,
			V2Actions,
			ModalInner,
			ConfirmationModal
		},
		mixins: [actionClick, routeParams],
		data: () => ({
			activity: {
				title: '',
				type: ''
			},
			deleteConfirmationIsVisible: false
		}),
		computed: {
			getBreadcrumbRoute () {
				if (!this.getCourseId) {
					return false;
				}
				return `/teaching/courses/${this.getCourseId}/lessons/${this.getLessonId}/activities`;
			},
			getActivityTitle () {
				if (!this.activity) {
					return false;
				}
				return this.activity.title;
			},
			getActions () {
				return {
					primary: [
						{
							text: 'Edit',
							route: `${this.getBreadcrumbRoute}/${this.getActivityId}/edit?type=${this.activity.type}`
						},
						{
							text: 'Duplicate',
							actionId: 'duplicate'
						}
					],
					secondary: [
						{
							text: 'Delete activity',
							actionId: 'deleteActivity'
						}
					]
				};
			},
			getBreadcrumbs () {
				return [
					{
						path: '/teaching',
						text: 'Teaching'
					},
					{
						path: this.getCoursesRoute,
						text: 'Courses'
					},
					{
						path: this.getCourseRoute,
						text: this.activity.courseTitle ? this.activity.courseTitle : 'Course'
					},
					{
						path: this.getLessonRoute,
						text: this.activity.lessonTitle ? this.activity.lessonTitle : 'Lesson'
					},
					{
						path: this.getActivityPreviewRoute,
						text: this.getActivityTitle
					}
				].filter(Boolean);
			}
		},
		created () {
			this.setActivity();
		},
		methods: {
			async setActivity () {
				const activity = await api.teaching.getActivityByIdAndLessonId({
					lessonId: this.getLessonId,
					activityId: this.getActivityId
				});
				if (!activity) {
					this.$store.commit('ui/showError');
					return false;
				}
				this.activity = activity;
				this.$store.commit('ui/setBreadcrumbs', {
					breadcrumbs: this.getBreadcrumbs
				});
				this.$store.commit('ui/setLoadingIsHidden');
			},
			editActivityRoute (activityId) {
				return `/teaching/courses/${this.getCourseId}/lessons/${this.getLessonId}/activities/${activityId}/edit?type=${this.activity.type}`;
			},
			async duplicate () {
				this.$store.commit('ui/showNotification', {
					notification: 'Duplicate me!'
				});
				// prefix or suffix the activity item title
				// TODO: be cleverer about the prefix/suffix
				const titlePrefix = '';
				const titleSuffix = ' - copy';
				// Call duplicate endpoint
				const newActivity = await api.teaching.duplicateActivityByLessonAndActivityId({
					lessonId: this.getLessonId,
					activityId: this.getActivityId,
					prefix: titlePrefix,
					suffix: titleSuffix
				});
				this.$router.push(this.editActivityRoute(newActivity.id));
				this.$store.commit('ui/showNotification', {
					notification: `The activity has been duplicated as ${newActivity.title}`
				});
			},
			toggleDeleteConfirmation () {
				this.deleteConfirmationIsVisible = !this.deleteConfirmationIsVisible;
			},
			async deleteActivity () {
				const response = await api.teaching.deleteActivityByIdAndLessonId({
					activityId: this.getActivityId,
					lessonId: this.getLessonId
				});
				if (!response) {
					return false;
				}
				await this.$router.push(this.getLessonRoute);
				this.$store.commit('ui/showNotification', {
					notification: 'Activity has been deleted'
				});
			}
		}
	};
</script>

<style lang="scss" scoped>
	[data-route] {
		[data-component='activity'] {
			margin-bottom:rem(32);
		}
		[data-component='actions'] {
		}
	}
</style>
